import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import { useTranslation } from "context/LanguageContext";
import { getCurrentClientConfig } from "config/clientConfig";

export default function Footer() {
  const { language, t } = useTranslation();
  const isRTL = language === 'ar';
  const contact = getCurrentClientConfig()?.contact || {};

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <span className="text-2xl">🛒</span>
              {t('ourStore')}
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              {t('storeDescription')}
            </p>
            <div className="flex gap-3">
              <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-gray-600 p-2 rounded-full transition-all duration-300 hover:scale-110">
                <FaWhatsapp className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-gray-600 p-2 rounded-full transition-all duration-300 hover:scale-110">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-gray-600 p-2 rounded-full transition-all duration-300 hover:scale-110">
                <FaFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('home')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('products')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('specialOffers')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('aboutUs')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('contactUs')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">{t('customerService')}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('returnPolicy')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('shippingDelivery')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('termsConditions')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('privacyPolicy')}</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors duration-200 hover:pr-2 inline-block">{t('faq')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">{t('contactInfo')}</h3>
            <p className="text-gray-300 leading-relaxed mb-3">{contact.info || t('storeDescription')}</p>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>{contact.location || t('location')}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <a href={`tel:${contact.phoneDial}`} className="hover:text-white transition-colors">{contact.phoneDisplay}</a>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors">{contact.email}</a>
              </div>
              <div className="flex items-start gap-3 text-gray-300">
                <Clock className="w-5 h-5 mt-1 flex-shrink-0" />
                <div>
                  <p>{contact.workingHours || t('workingHours')}</p>
                  <p>{contact.workingTime || t('workingTime')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-300 text-sm">
            <p>{t('copyright')}</p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-white transition-colors">{t('privacyPolicy')}</a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors">{t('termsConditions')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
